<template>
  <div class="row">
    <div class="col-4">
      <OperatorSelect @changed="operatorChanged" :selected="value.operator" :display="displayedOperators" />
    </div>
    <div class="col-8">
      <filter-select
        v-if="!['empty', 'not_empty'].includes(value.operator)"
        :selected="selected"
        ref="filterSelect"
        :placeholder="placeholder"
        :multiple="multiple"
        @filter="filterSearch"
        @changed="selectChanged"
      />
    </div>
  </div>
</template>

<script>
import OperatorSelect from "./OperatorSelect";

/*
const watchHandler = {
  handler() {
    this.list();
  },
};
*/
export default {
  props: ["value", "store", "placeholder", "multiple", "operators"],
  components: { OperatorSelect },
  /* 
  data() {
    return {
      request: {
        query: { name: undefined, scope: { type: "system" } },
        pagination: { limit: 50, total: 0, page: 1 },
        sort: {},
      },
      records: undefined,
    };
  },
 
  watch: {
    "request.pagination.limit": watchHandler,
    "request.pagination.page": watchHandler,
    "request.query": {
      deep: true,
      ...watchHandler,
    },
  },
  */
  mounted() {
    //this.list();
  },
  computed: {
    displayedOperators: {
      get() {
        return this.operators ? this.operators : ["in", "not_in", "some", "every"];
      },
    },
    selected: {
      get() {
        if (this.value && this.value.value) {
          if (Array.isArray(this.value.value)) {
            return this.value.value.map((s) => ({ _id: s._id, name: s.name }));
          }
          return this.value.value;
        }
        return [];
      },
    },
  },

  methods: {
    async filterSearch(value, callback) {
      const payload = {
        options: { limit: 1000 },
        query: { name: { value }, "scope.value": { value: "system", isObject: true } },
      };

      if (this.store == "role") {
        delete payload.query;
      }

      const response = await this.$store.dispatch(`${this.store}/paginate`, payload);

      callback(response.data?.docs ?? []);
    },
    /*
    async list() {
      try {
        const {
          data: { record, pagination, filter },
        } = await this.store.query(this.request);
        this.records = record;

        this.request.pagination = {
          ...pagination,
          limit: filter.pagination.limit,
        };
      } catch (error) {}
    },
    */
    selectChanged(selected) {
      this.$emit("selectChanged", selected);
    },
    operatorChanged(operator) {
      this.$emit("operatorChanged", operator);
    },
  },
};
</script>
